// CANONICAL COPY (GH #7115). src/constants/obligations/obl-bcp-plan.js re-exports this file so the browser and the
// Function App share one compliance engine — one definition of "compliant". Edit here, never there.
'use strict';

module.exports = {
  id: 'obl-bcp-plan',
  title: 'Verify business continuity plan exists',
  description:
    'Confirm that an ICT continuity / BCP plan is published and covers information security requirements during disruption, recovery time/point objectives and backup policy references.',
  category: 'continuity',
  scfIds: ['SCF-BCM-002', 'SCF-BCM-001', 'SCF-BCM-003'],
  cadence: { frequency: '1y', anchor: 'domain' },
  strategy: 'all',
  fulfilmentCriteria: [
    { type: 'document-published', description: 'BCP / ICT continuity plan is published' },
    { type: 'document-within-sla', description: 'Plan review is not overdue' },
  ],
  domainActions: [{ type: 'approve-document', label: 'Approve Document' }],
};
